export default "__VITE_ASSET__yAESajok__"